import { useState } from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Container, Navbar, Nav, NavDropdown, Dropdown } from 'react-bootstrap';
import { AuthenticatedTemplate } from '@azure/msal-react';
import { AppUser, useAppContext } from './AppContext';
import { FaBell } from 'react-icons/fa';
import styles from './NavBar.module.css';

interface UserAvatarProps {
  user?: AppUser;
}

function UserAvatar(props: UserAvatarProps) {
  return (
    <img
      src={props.user?.avatar || '/images/default-user-image.jpg'}
      alt="user"
      className="rounded-circle align-self-center mr-2"
      style={{ width: '32px' }}
    />
  );
}

export default function NavBarLarge() {
  const { user, signOut, requestsCount } = useAppContext();
  const [navExpanded, setNavExpanded] = useState(false);

  const handleNavDropdownToggle = (isOpen: boolean) => {
    if (isOpen) {
      setNavExpanded(false);
    }
  };

  return (
    <Navbar bg="dark" variant="dark" expand="md" sticky="top" onToggle={setNavExpanded} expanded={navExpanded}>
      <Container>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="me-auto mb-2 mb-md-0">
            <AuthenticatedTemplate>
              <Nav.Link as={RouterNavLink} to="/" className="nav-link">Agenda</Nav.Link>
              {/* <Nav.Link as={RouterNavLink} to="/organica" className="nav-link">Orgánica</Nav.Link> */}
              <Nav.Link as={RouterNavLink} to="/organigrama" className="nav-link">Organigrama</Nav.Link>
              <Nav.Link as={RouterNavLink} to="/establecimientos" className="nav-link">Establecimientos</Nav.Link>
            </AuthenticatedTemplate>
          </Nav>
        </Navbar.Collapse>
        <Nav className={`align-items-center ${styles.nav}`}>
          <AuthenticatedTemplate>
            {user?.admin && (
              <div className="d-flex align-items-center">
                <Nav.Link as={RouterNavLink} to="/admin" className={`nav-link ${styles.navLink}`}>
                  Admin
                </Nav.Link>
                <Nav.Link as={RouterNavLink} to="/solicitudes" className={`nav-link ${styles.navLink}`}>
                  <div className={styles.notificationIconWrapper}>
                    <FaBell className={styles.notificationIcon} />
                    {requestsCount > 0 && (
                      <span className={styles.notificationCount}>{requestsCount}</span>
                    )}
                  </div>
                </Nav.Link>
              </div>
            )}
            <NavDropdown
              title={<UserAvatar user={user} />}
              id="user-dropdown"
              align="end"
              onToggle={handleNavDropdownToggle}
            >
              <Dropdown.Header className="d-flex align-items-center">
                <UserAvatar user={user} />
                <div className="ms-2">
                  <h6 className={`m-0 ${styles.colorfontUser}`}>{user?.displayName}</h6>
                  <small className={styles.colorfontUser}>{user?.email}</small>
                </div>
              </Dropdown.Header>
              <Dropdown.Divider />
              <Nav.Link as={RouterNavLink} to="/usuario" className={styles.navMisDatos}>Mis datos</Nav.Link>
              <Dropdown.Item onClick={signOut}>Cerrar sesión</Dropdown.Item>
            </NavDropdown>
          </AuthenticatedTemplate>
        </Nav>
      </Container>
    </Navbar>
  );
}
